import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="container-furn flex min-h-[60vh] flex-col items-center justify-center text-center">
      <span className="font-display text-7xl font-bold text-accent">404</span>
      <h1 className="mt-4 font-display text-3xl font-bold uppercase">Line's snapped</h1>
      <p className="mt-3 max-w-md text-muted-foreground">The page you're after has got away. Let's get you back to the bank.</p>
      <Link to="/" className="mt-6 bg-accent px-8 py-4 text-xs font-bold uppercase tracking-widest text-accent-foreground">Back to home</Link>
    </div>
  );
}
